import { render, staticRenderFns } from "./ProgramTable.vue?vue&type=template&id=1942e34e&scoped=true&"
import script from "./ProgramTable.vue?vue&type=script&lang=js&"
export * from "./ProgramTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTable.vue?vue&type=style&index=0&id=1942e34e&scoped=scss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942e34e",
  null
  
)

export default component.exports